export const TIMELINE = [
  {
    era: "Mythic Origins",
    title: "Creation at Ilé-Ifẹ̀",
    text: "Yorùbá tradition holds that the world was created at Ilé-Ifẹ̀, where Odùduwà (or Ọbàtálá) established land, life, and kingship. Ifẹ̀ becomes the sacred cradle of Yorùbá civilisation.",
  },
  {
    era: "c. 500 BCE – 500 CE",
    title: "Early Settlement",
    text: "Ancestral Yorùbá communities settle across the forests and savannahs of West Africa, developing agriculture, iron-working, and the town-based society that will define the culture.",
  },
  {
    era: "11th – 15th Century",
    title: "The Golden Age of Ifẹ̀",
    text: "Ilé-Ifẹ̀ flourishes as a powerful city-state, producing the world-famous naturalistic bronze and terracotta heads — masterpieces of global art and evidence of a sophisticated urban civilisation.",
  },
  {
    era: "14th – 16th Century",
    title: "Rise of the City-States",
    text: "A network of Yorùbá kingdoms emerges — Ifẹ̀, Ìjẹ̀bú, Kétu, Ọ̀wọ̀, and others — each led by an ọba tracing legitimacy to Odùduwà, united by shared language and religion.",
  },
  {
    era: "17th – 18th Century",
    title: "The Ọ̀yọ́ Empire at its Height",
    text: "Ọ̀yọ́ becomes the dominant Yorùbá power, its cavalry commanding trade routes across the savannah. The Aláàfin rules with the Ọ̀yọ́ Mèsì council in a balanced system of governance.",
  },
  {
    era: "Early 19th Century",
    title: "Collapse and the Yorùbá Wars",
    text: "The Ọ̀yọ́ Empire fragments amid internal conflict and external pressure. Decades of war reshape Yorùbáland and, tragically, feed the transatlantic slave trade — carrying Yorùbá culture to the Americas.",
  },
  {
    era: "1800s",
    title: "The Great Diaspora",
    text: "Hundreds of thousands of Yorùbá are taken to Brazil, Cuba, Trinidad, and beyond. There, their spirituality survives and transforms into Candomblé, Santería, and Òrìṣà traditions still thriving today.",
  },
  {
    era: "Late 19th – 20th Century",
    title: "Colonialism and Endurance",
    text: "British colonial rule reshapes governance, yet Yorùbá kingship, festivals, and identity endure. Scholars, writers, and artists lead a proud cultural revival.",
  },
  {
    era: "2005",
    title: "Ifá Recognised by UNESCO",
    text: "UNESCO proclaims the Ifá divination system a Masterpiece of the Oral and Intangible Heritage of Humanity — global recognition of Yorùbá philosophy and wisdom.",
  },
  {
    era: "Today",
    title: "A Global Living Culture",
    text: "With over 45 million people and a vast diaspora — including communities in the United States — Yorùbá culture thrives worldwide through music, film, spirituality, and a renewed pride in heritage.",
  },
];
